module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAM1BMVEUAAAAwMDAyMjIwMDAyMjIyMjIzMzMwMDAyMjIwMDAyMjIyMjIyMjIzMzMzMzMzMzMzMzN/KD9wAAAAEHRSTlMAP38gYPCgEJ8w0N/AsG9QUM+TNwAAAJhJREFUOMvl0zsOAyEMRVGMwUz+b/+rTTEijniOQJkuuSU6MqYg/XsqlEauIKiwU4TxTAOKDD0AG12ruCbKeGQGJNzHaGDNQZdxpOBj8jWUFCTHoO4P0CkUWuooDFLfhCA3h2URGrYl2M5wyZAlw6lkKPC2VQgh6Gneu/lHdHiXV/30VN31I7zHzjOGrbthptDVxd0kTT/aE4B5EEvFWCHQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/theme-chalk/src/images/icon-export@2x.png
// module id = 91
// module chunks = 0